import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SearchEntityType } from '@tribeplatform/gql-client/types';
import { dayjs } from '../common/lib/dayjs';
import { T } from '../i18n';
export const SearchSubtitle = ({ hit }) => {
    const { entityType, in: space, by: author, content, created } = hit || {};
    switch (entityType) {
        case SearchEntityType.member:
        case SearchEntityType.space:
            return _jsx(_Fragment, { children: content }, void 0);
        case SearchEntityType.External:
            return _jsx(_Fragment, { children: content }, void 0);
        case SearchEntityType.post:
        default:
            // eslint-disable-next-line no-case-declarations
            const authorName = (author === null || author === void 0 ? void 0 : author.name) || 'Unknown';
            // eslint-disable-next-line no-case-declarations
            const time = dayjs(created).fromNow();
            // eslint-disable-next-line no-case-declarations
            const spaceName = (space === null || space === void 0 ? void 0 : space.name) || 'Untitled';
            return (_jsx(T, { defaultMessage: "Posted on {space} {time} by {author}", description: "The subtitle that appears under each search result", id: "SearchResult.Subtitle", values: {
                    space: _jsx("span", { className: "text-content", children: spaceName }, void 0),
                    author: _jsx("span", { className: "text-content", children: authorName }, void 0),
                    time,
                } }, void 0));
    }
};
//# sourceMappingURL=SearchSubtitle.js.map